/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemCameraSubjectRequestFromJSON(json) {
    return WallItemCameraSubjectRequestFromJSONTyped(json, false);
}
export function WallItemCameraSubjectRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'requestedForUserId': !exists(json, 'requested_for_user_id') ? undefined : json['requested_for_user_id'],
        'requestedForDeviceId': !exists(json, 'requested_for_device_id') ? undefined : json['requested_for_device_id'],
        'requestedCameraSubject': !exists(json, 'requested_camera_subject') ? undefined : json['requested_camera_subject'],
    };
}
export function WallItemCameraSubjectRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'requested_for_user_id': value.requestedForUserId,
        'requested_for_device_id': value.requestedForDeviceId,
        'requested_camera_subject': value.requestedCameraSubject,
    };
}
/**
* @export
* @enum {string}
*/
export var WallItemCameraSubjectRequestRequestedCameraSubject;
(function (WallItemCameraSubjectRequestRequestedCameraSubject) {
    WallItemCameraSubjectRequestRequestedCameraSubject["PERSON"] = "CAMERA_SUBJECT_PERSON";
    WallItemCameraSubjectRequestRequestedCameraSubject["SCREEN"] = "CAMERA_SUBJECT_SCREEN";
    WallItemCameraSubjectRequestRequestedCameraSubject["WORLD"] = "CAMERA_SUBJECT_WORLD";
})(WallItemCameraSubjectRequestRequestedCameraSubject || (WallItemCameraSubjectRequestRequestedCameraSubject = {}));
//# sourceMappingURL=WallItemCameraSubjectRequest.js.map